'use client';

import { FullListing } from '@th/shared/src/types/FullListing';
import { Agent } from '@th/shared/src/types/Agent';
import { useState } from 'react';
import WatchedNeighborhoodCard from './WatchedNeighborhoodCard';
import SigninCard from '../SigninCard';
import PropertyInquiryCard from '../PropertyInquiryCard';
import PropertyInquiryModal from './PropertyInquiryModal';

type Props = {
  listing: FullListing;
  isBlurred: boolean;
  agent: Agent | null;
};

export default function PropertyInquirySection({
  listing,
  isBlurred,
  agent,
}: Props) {
  const [isPropertyInquiryModalOpen, setIsPropertyInquiryModalOpen] =
    useState(false);

  return (
    <>
      <PropertyInquiryModal
        listing={listing}
        agent={agent}
        isOpen={isPropertyInquiryModalOpen}
        onClose={() => {
          setIsPropertyInquiryModalOpen(false);
        }}
      />
      <div className="hidden sm:block" style={{ flex: 1 }}>
        <div className="top-8 sticky">
          <div className="pl-12 py-12">
            {listing.address.neighborhood && (
              <WatchedNeighborhoodCard listing={listing} className={'mb-6'} />
            )}
            {isBlurred ? (
              <SigninCard />
            ) : (
              <PropertyInquiryCard listing={listing} agent={agent} />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
